<template lang="pug">
  #app(:class='{"sidebar-visible":menuActive||menuHover, "menu-pin sidebar-open":menuActive}')
    Sidebar(
      v-if="routesPure.length>0"
      :class='{"visible":menuActive}'
      :menuActive='menuActive'
      :routesPure='routesPure'
      @changeHover='changeHover')
    #container.page-container(:class='{"container-active":menuActive}')
      Topbar(:realName='realName'
        :routesPure='routesPure')
      .page-content-wrapper
        .content
          router-view
    .loadpage(v-show="loading")
      .loader
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

import { getAccount, expire } from '@/utils/auth'

import Sidebar from './Sidebar'
import Topbar from './Topbar'

export default {
  name: 'hello',
  components: {
    Sidebar,
    Topbar
  },
  data () {
    return {
      loading: true,
      menuHover: false,
      routesPure: [],
      realName: ''
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    const that = this
    that.windowResize()
    window.onresize = () => {
      return (() => {
        that.windowResize()
      })()
    }
  },
  created () {
    getAccount((response) => {
      this.loading = false
      this.realName = response.name
      this.routesPure = response.menus.map(item => {
        return {
          ...item,
          isOpen: true,
          isActive: false
        }
      })
    })
  },
  computed: {
    ...mapGetters([
      'menuActive'
    ])
  },
  methods: {
    ...mapMutations([
      'windowResize'
    ]),
    changeHover (state) {
      this.menuHover = state
    }
  }
}
</script>

<style lang="sass" scoped>
// .page-content-wrapper
//   overflow: hidden
.page-container
  position: relative
</style>



// WEBPACK FOOTER //
// index.vue?c763ecca